import { render, staticRenderFns } from "./ClassDetail.vue?vue&type=template&id=135921e0&scoped=true"
import script from "./ClassDetail.vue?vue&type=script&lang=js"
export * from "./ClassDetail.vue?vue&type=script&lang=js"
import style0 from "./ClassDetail.vue?vue&type=style&index=0&id=135921e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135921e0",
  null
  
)

export default component.exports